// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { TRAYS, WEIGHT_UNITS, WEIGHT_UNITS_SHORT, type WeightUnitPlusTrays } from '@seedplanner/shared-utils';
import { formatNumber } from './formatNumber';

export const formatOrderInput = ({
  quantity,
  sizeAmount,
  sizeUnit,
  language = 'en-US',
}: {
  readonly quantity: string | number;
  readonly sizeAmount?: string | number | null; // grams | ounces | trays
  readonly sizeUnit: WeightUnitPlusTrays;
  readonly language?: string;
}): string => {
  // Change plural to singular if quantity/sizeAmount is 1
  // If quantity is 1 and sizeUnit is trays, return '1 tray'
  if ((quantity === 1 || quantity === '1') && sizeUnit === TRAYS) {
    return '1 tray';
  }

  const formattedQuantity = formatNumber(
    typeof quantity === 'number' ? quantity : Number.parseFloat(quantity),
    language,
  );

  return `${formattedQuantity} ${sizeAmount ? `x ${sizeAmount}` : ''} ${shortenSizeUnit(sizeUnit)}`;
};

export const formatContainerInput = ({
  sizeAmount,
  sizeUnit,
}: {
  readonly sizeAmount?: string | number | null;
  readonly sizeUnit: string;
}): string => `${sizeAmount ? `${sizeAmount} ` : ''}${shortenSizeUnit(sizeUnit)}`;

// TODO: use stricter types here (and cascading)
export const shortenSizeUnit = (sizeUnit: string): string => {
  if (sizeUnit === WEIGHT_UNITS.GRAMS) {
    return WEIGHT_UNITS_SHORT.GRAMS;
  }
  if (sizeUnit === WEIGHT_UNITS.OUNCES) {
    return WEIGHT_UNITS_SHORT.OUNCES;
  }
  return sizeUnit;
};
